import {
  AvatarRootProps,
  HStack,
  Heading,
  HeadingProps,
  Text,
  VStack
} from "@chakra-ui/react"
import { UserFragment } from "@pathwright/graphql-client/src/generated"
import UserAvatar from "@pathwright/ux/src/components/avatar/UserAvatar"
import Link from "@pathwright/ux/src/components/link/Link"
import useTranslate from "@pathwright/ux/src/components/lng/useTranslate"
import Pathicon from "@pathwright/ux/src/components/pathicon/Pathicon"

type size = HeadingProps["size"] & AvatarRootProps["size"]

export type SignedInProps = {
  size?: size
  allowSignOut?: boolean
  onClickSignOut?: () => void
  user: UserFragment
}

const SignedIn = ({
  size = "sm",
  allowSignOut = true,
  onClickSignOut,
  user
}: SignedInProps) => {
  const { t } = useTranslate()

  return (
    <HStack className="SignedIn" gap={2} w="100%" p={2} pos="relative">
      <UserAvatar size={size} user={user} />
      <VStack alignItems="flex-start" gap={1} overflow="hidden" mr="auto">
        {/* TODO: use fontFamily="theme.heading" once the parent ChakraProvider uses correct heading theme font */}
        <Heading
          as="h1"
          className="theme-heading theme-heading-bold"
          size={size}
          m={0}
          lineClamp={1}
          maxW="100%"
          color="black"
        >
          {user.full_name}
        </Heading>
        <Text lineClamp={1} maxW="100%" as="span">
          {user.email}
        </Text>
      </VStack>
      {allowSignOut && (
        <Link
          to="/auth/sign-out"
          m={0}
          display="flex"
          flexShrink={0}
          onClick={onClickSignOut}
        >
          <Pathicon icon="arrow-up-line" transform="rotate(-90deg)" />
          {t("auth.sign_out")}
        </Link>
      )}
    </HStack>
  )
}

export default SignedIn
